import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

class DialogOverviewExampleDialog {
}

@Component({
    selector: 'app-delete-group-modal',
    templateUrl: './delete-group-modal.component.html',
    styleUrls: ['./delete-group-modal.component.scss']
})
export class DeleteGroupModalComponent implements OnInit {

  groupName: string;

  constructor(public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
              @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit(): void {
    this.groupName = this.data['groupTitle'];
  }

  deleteGroup() {
    this.dialogRef.close({shouldDelete: true, index: this.data['index']});
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
